import { render } from "./SearchResultsTable.vue?vue&type=template&id=4b85a090"
import script from "./SearchResultsTable.vue?vue&type=script&lang=js"
export * from "./SearchResultsTable.vue?vue&type=script&lang=js"

import "./SearchResultsTable.vue?vue&type=style&index=0&id=4b85a090&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__